module.exports = __webpack_public_path__ + "img/exposicaoPermanenteAzulBranco.4ef911bc.svg";